import Button from '@shared/components/Button/Button';
import cx from 'classnames';

import { ReactComponent as Notification } from 'assets/icons/Notification.svg';

import UnreadNotificationsCountBadge from './UnreadNotificationsCountBadge';

interface NotificationsButtonComponentProps {
  onClick?: () => void;
  className?: string;
}

const NotificationsButtonComponent = ({ onClick, className }: NotificationsButtonComponentProps) => (
  <Button
    size="neutral"
    variant="secondaryTertiary"
    className={cx('h-10 w-10 rounded-xl relative', className)}
    onClick={onClick}
  >
    <Notification className="stroke-1.5 h-5 w-5 stroke-current" />
    <UnreadNotificationsCountBadge />
  </Button>
);

export default NotificationsButtonComponent;
